module.exports = __webpack_public_path__ + "img/goods-mobile-1.bd478be0.png";